/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from 'pcln-design-system';
import Counter from '../Counter';
import { themeGet } from '@styled-system/theme-get';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "TravelerLineItem__StyledFlex",
  componentId: "sc-tq7b0c-0"
})(["height:52px;margin:", " 0;"], themeGet('space.2'));
function TravelerLineItem({
  autoFocus,
  className,
  count,
  label,
  min,
  max,
  subLabel,
  onChange
}) {
  return React.createElement(React.Fragment, null, React.createElement(StyledFlex, {
    className: className,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 1
  }, React.createElement(Flex, {
    flexDirection: 'column'
  }, React.createElement(Text, {
    fontSize: 2,
    mr: 1
  }, label), React.createElement(Text, {
    fontSize: 1,
    color: 'text.light'
  }, subLabel)), React.createElement(Counter, {
    autoFocus: autoFocus,
    label: label,
    min: min,
    max: max,
    count: count,
    onChange: onChange
  })));
}
export default TravelerLineItem;